import { ConditionTarget } from 'src/app/components/system/condition-builder/condition-builder.model';
import {
  ConditionValue,
  ConditionSource,
  LogicalOperator,
  ConditionItem
} from './../../../../system/condition-builder/condition-builder.model';
import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import {
  Activity,
  ActivityModel,
  DataEntityGroupLayoutModel,
  DataEntityLayoutModel
} from 'src/app/models/activities';
import { WorkflowContextService, WorkflowService } from 'src/app/services';
import { Workflow } from 'src/app/models';
import { DataEntityEditorComponent } from '../../data-entity-editor/data-entity-editor.component';
import {
  LAYOUT_DROP_LISTS,
  canEnterEntityLayout,
  registerLayoutDropList,
  unregisterLayoutDropList
} from '../../layout-drop-lists';

@Component({
  selector: 'wm-data-entity-group-layout-editor',
  templateUrl: './data-entity-group-layout-editor.component.html',
  styleUrl: './data-entity-group-layout-editor.component.css',
  standalone: false
})
export class DataEntityGroupLayoutEditorComponent implements OnInit, OnDestroy {
  @Input() layout: DataEntityGroupLayoutModel;
  @Input() workflow: Workflow;
  @Input() activity: Activity<ActivityModel>;
  @Input() form: UntypedFormGroup;
  @ViewChild('newDEEditor', { static: false })
  newDEEditor: DataEntityEditorComponent;

  newDEForm: UntypedFormGroup;
  showEditor: boolean;
  showConditionalVisible = false;
  conditionSources: ConditionSource[];

  saveNew() {
    this.layout.groupEntities.push(
      new DataEntityLayoutModel({ entity: this.newDEEditor.dataEntity })
    );
  }
  cancelNew() {
    this.showEditor = false;
  }
  loadEditor() {
    this.showEditor = true;
  }

  removeDataEntity(de, index: number) {
    this.layout.groupEntities.splice(index, 1);
  }

  viewDataentity(de) {}

  saveDataEntity(de) {
    // Update the data entity in the layout
  }


  visibleCriteriaChanged(e) {
    this.layout.visibleCriteria.group = e;
  }

  visibleConditionChanged() {
    // Handle checkbox state changes
    if (this.showConditionalVisible) {
      // Initialize condition criteria when enabling
      if (this.layout.visibleCriteria == null) {
        this.layout.visibleCriteria = new ConditionTarget({
          group: new ConditionItem({ isGroup: true }),
          value: 'Yes'
        });
      }
    } else {
      // Clear criteria when disabling (optional - you may want to preserve the criteria)
    }

    // Trigger change detection to ensure UI updates properly
    this._ref.detectChanges();
  }

  get columnEntities() {
    return this.layout?.groupEntities || [];
  }

  constructor(
    private _workflowSvc: WorkflowService,
    private _context: WorkflowContextService,
    private _ref: ChangeDetectorRef
  ) {}

  drop(event: CdkDragDrop<DataEntityLayoutModel[]>) {
    if (event.previousContainer === event.container) {
      // Same container - just reorder
      if (this.layout?.groupEntities) {
        moveItemInArray(
          this.layout.groupEntities,
          event.previousIndex,
          event.currentIndex
        );

        // Update display orders
        this.layout.groupEntities.forEach((entity, index) => {
          if (entity) {
            entity.displayOrder = index + 1;
          }
        });

        this._ref.detectChanges();
      }
    } else {
      // Different container - transfer item
      if (this.layout?.groupEntities && event.previousContainer.data) {
        transferArrayItem(
          event.previousContainer.data,
          this.layout.groupEntities,
          event.previousIndex,
          event.currentIndex
        );

        // Update display orders for both arrays
        this.layout.groupEntities.forEach((entity, index) => {
          if (entity) {
            entity.displayOrder = index + 1;
          }
        });

        // Update display orders for source array
        event.previousContainer.data.forEach((entity, index) => {
          if (entity) {
            entity.displayOrder = index + 1;
          }
        });

        this._ref.detectChanges();
      }
    }
  }

  onSaved(e) {
    // Handle save event
  }

  // unique per instance: a form can contain many Rows / Groups
  readonly dropListId = registerLayoutDropList('group-entities-list');
  readonly connectedDropLists = LAYOUT_DROP_LISTS;
  readonly canEnter = canEnterEntityLayout;

  ngOnDestroy(): void {
    unregisterLayoutDropList(this.dropListId);
  }

  ngOnInit(): void {
    this.newDEForm = new UntypedFormGroup({});

    // Initialize conditional visibility toggle based on existing criteria
    this.initializeConditionalVisibility();

    this._workflowSvc
      .getDataEntitiesBeforeMe(this._context.workflow, this.activity)
      .subscribe(entities => {
        this.conditionSources = entities.map(e => {
          return {
            name: e.templateCode,
            value: e.templateCode,
            operators: e.getAvailableOperators(),
            possibleValues: e.getPossibleValues()
          };
        });
      });
  }

  private initializeConditionalVisibility(): void {
    // Check if there are existing conditional criteria defined
    this.showConditionalVisible = this.hasConditionalCriteria();
  }

  private hasConditionalCriteria(): boolean {
    return !!(
      this.layout?.visibleCriteria &&
      this.layout.visibleCriteria.group &&
      this.layout.visibleCriteria.group.conditions?.length > 0
    );
  }

  /**
   * Call this method to refresh the conditional visibility state
   * based on current criteria. Useful when layout is updated externally.
   */
  public refreshConditionalVisibility(): void {
    this.showConditionalVisible = this.hasConditionalCriteria();
    this._ref.detectChanges();
  }
}
